import { useAuraContext } from '@/common/context/useAuraContext';
import '../../assets/scss/custom/components/_aura-fab-button.scss';
import AuraChat from './AuraChat';

export default function AuraChatFabButton() {
	const { toggleOpen, open } = useAuraContext();

	return (
		<>
			{open && <AuraChat />}

			{!open && <AuraButton toggleOpen={toggleOpen} />}
		</>
	);
}

interface AuraButtonProps {
	toggleOpen: () => void;
}

function AuraButton({ toggleOpen }: AuraButtonProps) {
	return (
		<>
			<button
				className="btn btn-primary rounded-circle shadow animate-greeting"
				style={{
					width: '4rem',
					height: '4rem',
				}}
				onClick={toggleOpen}
			>
				<i className="ri-brain-line fs-3"></i>
			</button>
		</>
	);
}
